import type { OnlineEvalIssueJudgment } from './online-eval.types';

export const describeJudgment = (judgment: OnlineEvalIssueJudgment): string => {
  switch (judgment.kind) {
    case 'explained':
      return judgment.confidence === null
        ? judgment.explanation
        : `${judgment.explanation} (confidence ${judgment.confidence.toFixed(2)})`;
    case 'scored':
      return `Confidence ${judgment.confidence.toFixed(2)} that the category applies`;
  }
};
